import React, { FC } from 'react'

type CheckboxItemProps = {
  id: string
  label: string
  name: string
  checked: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const CheckboxItem: FC<CheckboxItemProps> = ({ id, label, name, checked, onChange }) => {
  return (
    <div>
      <label>
        <input id={id} type='checkbox' name={name} checked={checked} onChange={onChange} />
        {label}
      </label>
    </div>
  )
}

//** CheckboxItem component */
// wrapper styled - pure styling wrapper (div) that takes the id and icon name
// icon wrapper
// icon
// icon wrapper

//** Checkbox component - can use radio button component type='Tick' */
// wrapper styled
// span
// input
// label
// span
// wrapper styled

// wrapper
